"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldToolbarColor = void 0;
var EmeraldToolbarColor;
(function (EmeraldToolbarColor) {
    EmeraldToolbarColor["None"] = "none";
    EmeraldToolbarColor["Primary"] = "primary";
    EmeraldToolbarColor["Accent"] = "accent";
    EmeraldToolbarColor["Warn"] = "warn";
})(EmeraldToolbarColor || (exports.EmeraldToolbarColor = EmeraldToolbarColor = {}));
//# sourceMappingURL=toolbar.color.js.map